// warranty
export const linkToPaidRepairLicense =
  'https://api-control.sputnik.systems/docs/paid_repair.pdf'
